import apiRequest from './apiRequest';
import type { SceneExportResponse } from './postExternalSceneExport';

export default async function getExternalSceneExport(
  apiKey: string,
  sceneID: string,
  objectReferenceNames?: string[],
) {
  const params = new URLSearchParams();
  if (objectReferenceNames?.length) {
    params.set('objectReferenceNames', objectReferenceNames.join(','));
  }

  const query = params.toString();

  return await apiRequest<SceneExportResponse>(
    'external-mogen',
    `/exports/scenes/${encodeURIComponent(sceneID)}${query ? `?${query}` : ''}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
